import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Button, Tooltip } from '@weave-mui/material';
import { usePermissions } from '../hooks/usePermissions';
const PermissionButton = ({ requiredAction, requireAll = true, children, showPermissionTooltip = true, disabled, title, ...props }) => {
    const { hasAction, hasAllActions, hasAnyAction } = usePermissions();
    let hasPermission = true;
    let missingPermissions = [];
    if (requiredAction) {
        const actions = Array.isArray(requiredAction) ? requiredAction : [requiredAction];
        if (requireAll) {
            hasPermission = hasAllActions(actions);
            if (!hasPermission) {
                missingPermissions = actions.filter((action) => !hasAction(action));
            }
        }
        else {
            hasPermission = hasAnyAction(actions);
            if (!hasPermission) {
                missingPermissions = actions;
            }
        }
    }
    const isDisabled = disabled || !hasPermission;
    let buttonTitle = title;
    if (!hasPermission && showPermissionTooltip) {
        buttonTitle = `Insufficient permissions. Required: ${missingPermissions.join(', ')}`;
    }
    const button = (_jsx(Button, { ...props, disabled: isDisabled, children: children }));
    if (buttonTitle && showPermissionTooltip) {
        return (_jsx(Tooltip, { title: buttonTitle, children: _jsx("span", { children: button }) }));
    }
    return button;
};
export default PermissionButton;
